import ApplicationController from './application_controller';
import '@github/details-dialog-element';

export default class extends ApplicationController {
  close(event) {
    window.location.hash = '';
    history.replaceState(null, document.title, location.pathname + location.search);
  }
}